import React from 'react';
import { Shield } from 'lucide-react';

interface GmpCertificationsTooltipProps {
  certifications: string[];
  position: { top: number; left: number };
  contentRef?: React.RefObject<HTMLDivElement>;
  id?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

/**
 * Names the GMP certifications a CDMO holds, so the result card can stay summarised as a count.
 * Shares the visual language of the other card overlays.
 */
const GmpCertificationsTooltip: React.FC<GmpCertificationsTooltipProps> = ({
  certifications,
  position,
  contentRef,
  id,
  onMouseEnter,
  onMouseLeave,
}) => (
  <div
    ref={contentRef}
    id={id}
    role="tooltip"
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    style={{ position: 'fixed', top: position.top, left: position.left, zIndex: 9999 }}
    className="w-64 bg-white/95 backdrop-blur-sm border border-white/50 rounded-xl shadow-xl p-4"
  >
    {/* "Regulatory / GMP" rather than "Certifications": some stored values are regulatory markets
        the CDMO supports, not formal certificates it holds (§6.3). */}
    <h4 className="text-sm font-bold text-charcoal mb-2 flex items-center">
      <Shield className="w-4 h-4 mr-2 shrink-0 text-lime-green" aria-hidden="true" />
      Regulatory / GMP
    </h4>
    <ul className="space-y-1.5">
      {certifications.map(certification => (
        <li key={certification} className="flex items-start text-xs text-slate-gray">
          <span
            className="mr-2 mt-1.5 h-1 w-1 shrink-0 rounded-full bg-lime-green"
            aria-hidden="true"
          />
          <span>{certification}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default GmpCertificationsTooltip;
